import { Pipe, PipeTransform, Inject, LOCALE_ID } from '@angular/core'; 
import moment from 'moment-timezone';
@Pipe({
    name: 'DateFormatConversion',
    standalone: false
})
export class DynamicDateConversionPipe implements PipeTransform {

  constructor(){}
  transform(value: string | undefined, format: string ="ll") {
    const formats = ["DD/MM/YYYY", "YYYY-MM-DD", "MM/DD/YYYY"]
    if(value){
        return moment(value, formats).format(format)
    }
    return value
  }
}